import { z } from 'zod'
import { useZodForm } from '@minetrace/ui/forms'

export const step3AccountSchema = z.object({
  enableUserAccount: z.boolean(),
  username: z.string().optional(),
  password: z.string().optional(),
  isExternal: z.boolean(),
  hasWebAccess: z.boolean(),
})

export type Step3AccountFormValues = z.infer<typeof step3AccountSchema>

const defaultValues: Step3AccountFormValues = {
  enableUserAccount: false,
  username: '',
  password: '',
  isExternal: false,
  hasWebAccess: true,
}

export const useStep3AccountForm = (props?: { defaultValues?: Step3AccountFormValues }) =>
  useZodForm<Step3AccountFormValues>({
    validationSchema: step3AccountSchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
